export const EMPTY_PLACEHOLDER = '<EMPTY>';
export const ANY = '*';
export const NO_SELECTION = '';
/** Indicates that the requested product or add-on was unable to be found on the triggering account */
export const PRODUCT_NOT_FOUND = 'PRODUCT-404';
export const ADDON_NOT_FOUND = 'ADDON-404';
/** Indicates that the action should apply to all products on the account. */
export const ALL_PRODUCTS = '<ALL-PRODUCTS>';
